import Raven from 'raven-js';
import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { teaseNotificationsComponentDef } from 'navigation-components/config';
import { useOnFunctionCalled } from 'navigation-components/consumer/hooks';
import { getUser } from '../../selectors';
import { startBrowserNotifications } from '.';
import { handleWebsocketNotification } from './handleWebsocketNotification';
import { getPrimaryTabUtil } from '../../utils/PrimaryTabUtil';
export const BrowserNotifications = () => {
  const user = useSelector(getUser);
  const {
    registerCallback
  } = useOnFunctionCalled(teaseNotificationsComponentDef);
  useEffect(() => {
    startBrowserNotifications(user.user_id).catch(e => Raven.captureException(e));
  }, [user.user_id]);
  const onNotification = useCallback(notification => {
    handleWebsocketNotification(notification.notification, getPrimaryTabUtil().isPrimary);
  }, []);
  useEffect(() => registerCallback('onNewNotification', onNotification), [onNotification, registerCallback]);
  return null;
};